import {InvoicePartsAndLabourDetailsApiDto, UpdateInvoiceLabourApiDto} from "../../api/model/rest";
import JsonConverter from "../../api/helper/JsonConverter";
import NumberUtils from "../../utils/NumberUtils";
import {Option} from "ts-option";

export default class InvoicePartsAndLabourDetails {

	constructor(public readonly hiberFee: number,
		public readonly hiberFeeTax: number,
		public readonly hiberPartsMargin: number,
		public readonly labour: number,
		public readonly partnerPartsMargin: number,
		public readonly description: string,
		public readonly selfSourcedItemsSubtotal: number,
		public readonly selfSourcedItemsTax: number) {}

	static fromJson(json: InvoicePartsAndLabourDetailsApiDto): InvoicePartsAndLabourDetails {
		return new InvoicePartsAndLabourDetails(json.hiberFee, json.hiberFeeTax, json.hiberPartsMargin, json.labour,
			json.partnerPartsMargin, json.description, json.selfSourcedItemsSubtotal, json.selfSourcedItemsTax);
	}

	toJson(): UpdateInvoiceLabourApiDto {
		const json: UpdateInvoiceLabourApiDto = {
			labour: this.labour,
			description: this.description
		};
		return JsonConverter.removeEmptyFields(json);
	}

	copy({
		labour = this.labour,
		description = this.description
	}): InvoicePartsAndLabourDetails {
		return new InvoicePartsAndLabourDetails(this.hiberFee,
			this.hiberFeeTax,
			this.hiberPartsMargin,
			labour,
			this.partnerPartsMargin,
			description,
			this.selfSourcedItemsSubtotal,
			this.selfSourcedItemsTax);
	}

	getSubtotal() {
		return NumberUtils.roundToMaxTwoDecimals(
			this.hiberFee + this.hiberPartsMargin + this.labour + this.partnerPartsMargin + this.selfSourcedItemsSubtotal);
	}

	getTotal(vatRegistered: boolean, vatRate: Option<number>) {
		if (!vatRegistered || vatRate.isEmpty) {
			return this.getSubtotal();
		}
		return NumberUtils.roundToMaxTwoDecimals(this.getSubtotal() + this.getVatAmount(vatRegistered, vatRate));
	}

	getVatAmount(vatRegistered: boolean, vatRate: Option<number>) {
		if (!vatRegistered || vatRate.isEmpty) {
			return 0;
		}
		const vatAsFraction = vatRate.get / 100;
		const hiberPartsMarginVatAmount = NumberUtils.roundToMaxTwoDecimals(this.hiberPartsMargin * vatAsFraction);
		const labourVatAmount = NumberUtils.roundToMaxTwoDecimals(this.labour * vatAsFraction);
		const partnerPartsMarginVatAmount = NumberUtils.roundToMaxTwoDecimals(this.partnerPartsMargin * vatAsFraction);
		return NumberUtils.roundToMaxTwoDecimals(
			this.hiberFeeTax + hiberPartsMarginVatAmount + labourVatAmount + partnerPartsMarginVatAmount +
			this.selfSourcedItemsTax);
	}
}
